import { memo } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../constants';
import { useCalendarGridStore } from '../store/calendar-grid.store';
import { CalendarNavigationConfig } from '../types';

const TopCornerCellsComponent = ({ onNext, onPrevious, canGoNext, canGoPrevious }: CalendarNavigationConfig) => {
  return (
    <>
      <div data-top-left-corner css={baseContainerStyle} style={{ left: 0, gridColumn: 1 }}>
        <Button variant='secondary' iconName='caret-left' disabled={!canGoPrevious} onClick={onPrevious} />
      </div>
      <div data-top-right-corner css={baseContainerStyle} style={{ right: 0, gridColumn: '-2 / -1' }}>
        <Button variant='secondary' iconName='caret-right' disabled={!canGoNext} onClick={onNext} />
      </div>
    </>
  );
};

const TopCornerCellsForScroll = ({ onScroll }: { onScroll: (direction: 'left' | 'right') => void }) => {
  const { canScrollLeft, canScrollRight } = useCalendarGridStore(['canScrollLeft', 'canScrollRight']);

  return (
    <TopCornerCellsComponent
      onNext={() => onScroll('right')}
      onPrevious={() => onScroll('left')}
      canGoNext={canScrollRight}
      canGoPrevious={canScrollLeft}
    />
  );
};

interface TopCornerCellsProps {
  onScroll: (direction: 'left' | 'right') => void;
  navigationConfig?: CalendarNavigationConfig;
}

export const TopCornerCells = memo(({ onScroll, navigationConfig }: TopCornerCellsProps) => {
  if (navigationConfig) return <TopCornerCellsComponent {...navigationConfig} />;

  return <TopCornerCellsForScroll onScroll={onScroll} />;
});
TopCornerCells.displayName = 'TopCornerCells';

const baseContainerStyle = css({
  gridRow: 1,
  backgroundColor: theme.colors.neutral5,
  boxShadow: theme.shadows.light,
  zIndex: CALENDAR_Z_INDICES.topCornerCell,
  position: 'sticky',
  top: 0,
  button: {
    maxWidth: 'var(--group-separator-width)',
    borderRadius: 0,
    height: '100%',
    width: '100%',
  },
});
